class SearchBar extends HTMLElement {
  _boundHandlers = {};

  static observedAttributes = ['placeholder'];

  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    this._attachEventListeners();
  }

  disconnectedCallback() {
    this._removeEventListeners();
  }

  attributeChangedCallback() {
    this.render();
    this._attachEventListeners();
  }

  get placeholder() {
    return this.getAttribute('placeholder') || 'Search notes...';
  }

  _removeEventListeners() {
    const input = this.querySelector('input');
    const clearBtn = this.querySelector('.search-bar-clear-btn');

    if (input && this._boundHandlers.inputHandler) {
      input.removeEventListener('input', this._boundHandlers.inputHandler);
    }
    if (input && this._boundHandlers.nativeSearchHandler) {
      input.removeEventListener('search', this._boundHandlers.nativeSearchHandler);
    }
    if (input && this._boundHandlers.keydownHandler) {
      input.removeEventListener('keydown', this._boundHandlers.keydownHandler);
    }
    if (clearBtn && this._boundHandlers.clearHandler) {
      clearBtn.removeEventListener('click', this._boundHandlers.clearHandler);
    }
  }

  _attachEventListeners() {
    const input = this.querySelector('input');
    const clearBtn = this.querySelector('.search-bar-clear-btn');

    this._boundHandlers.inputHandler = () => {
      this.dispatchEvent(
        new CustomEvent('search', {
          detail: { query: input.value },
          bubbles: true,
        })
      );
      if (clearBtn) {
        clearBtn.style.display = input.value ? 'flex' : 'none';
      }
    };

    this._boundHandlers.clearHandler = () => {
      input.value = '';
      input.focus();
      this.dispatchEvent(
        new CustomEvent('search', {
          detail: { query: '' },
          bubbles: true,
        })
      );
      clearBtn.style.display = 'none';
    };

    // Handle native search event (when user clicks browser's X button)
    this._boundHandlers.nativeSearchHandler = () => {
      this.dispatchEvent(
        new CustomEvent('search', {
          detail: { query: input.value },
          bubbles: true,
        })
      );
      if (clearBtn) {
        clearBtn.style.display = input.value ? 'flex' : 'none';
      }
    };

    // Prevent Enter key from triggering form submission or resetting search
    this._boundHandlers.keydownHandler = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    };

    input?.addEventListener('input', this._boundHandlers.inputHandler);
    input?.addEventListener('search', this._boundHandlers.nativeSearchHandler);
    input?.addEventListener('keydown', this._boundHandlers.keydownHandler);
    clearBtn?.addEventListener('click', this._boundHandlers.clearHandler);
  }

  render() {
    this._removeEventListeners();

    this.innerHTML = `
      <div class="search-bar-container" role="search">
        <div class="search-bar-icon" aria-hidden="true">
          <span class="material-symbols-outlined">search</span>
        </div>
        <input 
          type="search" 
          class="search-bar-input"
          placeholder="${this.placeholder}" 
          aria-label="${this.placeholder}"
        />
        <button type="button" class="search-bar-clear-btn" aria-label="Clear search">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
    `;
  }
}

customElements.define('search-bar', SearchBar);
